// eslint-disable-next-line space-before-function-paren
export default function ({ $axios, app, redirect, store }) {
  $axios.onError(async error => {
    if (error.response.status === 401 && error.response.data.errorCode !== 'INVALID-TOKEN') {
      app.$cookies.remove('auth');
      app.$cookies.remove('isGuest');

      await app.$auth.initialLogin();
      await redirect(app.localePath({ name: 'login' }));
      store.commit('layout/setLoader', false);
    } else {
      throw error;
    }
  });

  if (!process.server) {
    app.$cache.init();
  }
}
